(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4091],{

/***/ 5786:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thread/lambda-functions-in-python-with-code-snippets",
      function () {
        return __webpack_require__(5701);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "meta": function() { return /* binding */ meta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1151);
/* harmony import */ var _layouts_TwitterThreadLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1075);
/* harmony import */ var _components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6833);
/*@jsxRuntime automatic @jsxImportSource react*/ 



const meta = {
    url: "https://devsforgood.com/thread/lambda-functions-in-python-with-code-snippets",
    title: "Lambda functions in Python (with code snippets)",
    description: "Lambda Functions in Python (with code snippets)",
    image: "/covers/threads/lambda-functions-in-python-with-code-snippets.png",
    author: "Shreya Shivratriwar"
};
const MDXLayout = (param)=>{
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_TwitterThreadLayout__WEBPACK_IMPORTED_MODULE_1__/* .TwitterThreadLayout */ .T, {
        meta: meta,
        children: children
    });
};
function _createMdxContent(props) {
    const _components = Object.assign({
        p: "p",
        ul: "ul",
        li: "li",
        ol: "ol"
    }, (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_3__/* .useMDXComponents */ .ah)(), props.components);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadAuthor */ .vI, {
                name: "Shreya Shivratriwar",
                username: "shreyasico",
                avatarUrl: "/avatars/shreyasico.png"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadOriginalUrl */ .KN, {
                url: "https://twitter.com/shreyasico/status/1594584670179536896"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlockFirst */ .Iq, {
                image: "undefined",
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "Lambda Functions in Python (with code snippets)"
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "Thread \uD83E\uDDF5\uD83D\uDC47"
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "undefined",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                    children: "Python Lambda Functions are anonymous function means that the function is without a name."
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "undefined",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                    children: "As we already know that the def keyword is used to define a normal function in Python. Similarly, the lambda keyword defines an anonymous function in Python."
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/lambda-functions-in-python-with-code-snippets-3.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                    children: "Syntax of Lambda Functions in Python"
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "undefined",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ul, {
                    children: [
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.li, {
                            children: [
                                "\n",
                                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                                    children: "Lambda functions can have any number of arguments but only one expression."
                                }),
                                "\n"
                            ]
                        }),
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.li, {
                            children: [
                                "\n",
                                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                                    children: "The expression is evaluated and returned."
                                }),
                                "\n"
                            ]
                        }),
                        "\n",
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.li, {
                            children: [
                                "\n",
                                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                                    children: "Lambda functions can be used wherever function objects are required."
                                }),
                                "\n"
                            ]
                        }),
                        "\n"
                    ]
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/lambda-functions-in-python-with-code-snippets-5.png",
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "Example of a lambda function in Python"
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "This lambda function converts the string into uppercase and reverses it."
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/lambda-functions-in-python-with-code-snippets-6.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                    children: "Condition Checking Using Python lambda function"
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "undefined",
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "That's a wrap!"
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "If you enjoyed this thread:"
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                        children: [
                            "\n",
                            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                                children: "Follow me @shreyasico for more of these"
                            }),
                            "\n",
                            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                                children: "RT the tweet below to share this thread with your audience https://twitter.com/1383037577779761157/status/1594584670179536896"
                            }),
                            "\n"
                        ]
                    })
                ]
            })
        ]
    });
}
function MDXContent() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MDXLayout, Object.assign({}, props, {
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_createMdxContent, props)
    }));
}
/* harmony default export */ __webpack_exports__["default"] = (MDXContent);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4500,5675,2361,8411,9774,2888,179], function() { return __webpack_exec__(5786); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);